export default __webpack_public_path__ + "static/media/Arimo-Bold.cfaebbcb.ttf";